import React, { useState } from "react";
import apiClient from "../api/client";
import { PRESET_LABELS } from "../utils/permissions";

export default function AccountPage({ user }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const res = await apiClient.post(`/auth/change-password`, {
        currentPassword,
        newPassword,
      });
      setMessage(res.data.message || "הסיסמה עודכנה");
      setCurrentPassword("");
      setNewPassword("");
    } catch (err) {
      const msg = err.response?.data?.error || err.message;
      setError(msg);
    }
  };

  return (
    <div className="page">
      <div className="card">
        <h2 style={{ marginBottom: "4px" }}>החשבון שלי</h2>
        <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: "0 0 var(--space-lg) 0" }}>
          פרטי חשבון ושינוי סיסמה
        </p>

        <div className="form-grid" style={{ marginBottom: "var(--space-xl)" }}>
          <div className="field">
            <span style={{ color: "var(--text-secondary)", fontSize: "13px", display: "block", marginBottom: "6px" }}>שם מלא</span>
            <div style={{ fontSize: "15px" }}>{user.firstName} {user.lastName}</div>
          </div>
          <div className="field">
            <span style={{ color: "var(--text-secondary)", fontSize: "13px", display: "block", marginBottom: "6px" }}>אימייל</span>
            <div style={{ fontSize: "15px" }}>{user.email}</div>
          </div>
          <div className="field">
            <span style={{ color: "var(--text-secondary)", fontSize: "13px", display: "block", marginBottom: "6px" }}>תפקיד</span>
            <div style={{ fontSize: "15px" }}>{PRESET_LABELS[user.rolePreset] ?? user.rolePreset}</div>
          </div>
        </div>

        <h3 className="form-section-title">שינוי סיסמה</h3>
        <form onSubmit={handleChangePassword} className="form-grid">
          <div className="field">
            <label className="label">סיסמה נוכחית</label>
            <input
              className="input"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label className="label">סיסמה חדשה</label>
            <input
              className="input"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="field form-full-width">
            <button type="submit" className="btn btn-primary">
              עדכון סיסמה
            </button>
          </div>
        </form>

        {message && <p className="message-success" style={{ marginTop: "var(--space-md)", marginBottom: 0 }}>{message}</p>}
        {error && <p className="message-error" style={{ marginTop: "var(--space-md)", marginBottom: 0 }}>{error}</p>}
      </div>
    </div>
  );
}
